export default __webpack_public_path__ + "static/media/sitedownFire.db1b0c3a.png";